export default __webpack_public_path__ + "c65a30f2331499a01ec122f3084e6b9e.png";